// NETWORK
import RequestRabbit from './RequestRabbit';

// CONFIG
import config from '../Config';

const useCompanyProfileRequest = () => {
  /*
    Makes a request to fetch the Company Profile for the User.  This includes
    the Company Name, Address, and other details.
  
    Inputs:
      - None
  
    Outputs:
      - An object containing the Company Profile details.
  */
  const getCampaignDetails = async (campaignCode, errorHandler) => {
    try {
      const url = `${config.baseServerURL}/customer/campaign?campaignCode=${campaignCode}`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const getCustomerCampaigns = async (errorHandler) => {
    try {
      const url = `${config.baseServerURL}/customer/campaigns`;
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();

      return responseJSON;
    } catch (e) {
      errorHandler(e);
    }
  };

  const downloadAttachments = async (attachment, errorHandler) => {
    try {
      let url = `${config.baseServerURL}/customer/campaign/download`;
      if (attachment) {
        url += `?attachment=${attachment}`;
      }
      const options = {
        method: 'GET',
      };

      let response = await RequestRabbit.request(url, options, errorHandler);
      let responseJSON = await response?.json();
      console.log('responseJSON', responseJSON);
      responseJSON.map((item) => {
        const { filename, filePath } = item;
        const blob = new Blob([filePath], {
          type: 'application/octet-stream',
        });
        const downloadUrl = URL.createObjectURL(blob);
        const tempLink = document.createElement('a');
        tempLink.style.display = 'none';
        tempLink.href = downloadUrl;
        tempLink.setAttribute('download', filename);

        document.body.appendChild(tempLink);
        tempLink.click();
        document.body.removeChild(tempLink);

        URL.revokeObjectURL(downloadUrl);
      });
    } catch (e) {
      errorHandler(e);
    }
  };

  return { getCampaignDetails, getCustomerCampaigns, downloadAttachments };
};

export default useCompanyProfileRequest;
